'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { CatInputField } from '@blocks-react/components/InputField';
import { useController, useFormContext } from 'react-hook-form';
import styles from './MyEquipmentSerialInput.module.scss';
export const MyEquipmentSerialInput = ({ placeholder, name, rules, fieldNote, isError, maxLength, onChange, children, dataCsMask }) => {
    const { control, getValues, setValue } = useFormContext();
    const { field, fieldState } = useController({ name, control, rules });
    const serialNumber = getValues(name);
    const error = !!(isError ?? fieldState.error);
    const note = fieldNote ?? fieldState.error?.message;
    const onBlChange = (e) => {
        const inputValue = e.detail.value;
        if (serialNumber !== inputValue) {
            onChange(inputValue);
            field.onChange(e);
            setValue(name, inputValue);
        }
    };
    return (
    // TODO - Input Validation - Ensure that <,>,/,\ characters and <script> tags are not allowed to type/paste.
    _jsx(CatInputField, { hideLabel: true, type: "text", placeholder: placeholder, onBlChange: onBlChange, fieldNote: note, status: error ? 'error' : undefined, name: name, value: serialNumber, maxlength: maxLength, "data-testid": "serial_input_form", "data-cs-encrypt": dataCsMask, className: styles['serial_input'], children: children }));
};
